var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.52722 1.50136C7.15323 0.318888 8.84716 0.31888 9.47318 1.50135L15.5891 13.0536C16.1767 14.1636 15.3721 15.5001 14.1161 15.5001H1.88428C0.628328 15.5001 -0.176345 14.1636 0.411304 13.0536L6.52722 1.50136ZM14.1161 13.8334L8.0002 2.28117L1.88428 13.8334L14.1161 13.8334Z",
    fill: "#EE0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16686 6.33345C7.16686 5.87321 7.53996 5.50012 8.0002 5.50012C8.46043 5.50012 8.83353 5.87321 8.83353 6.33345V9.66678C8.83353 10.127 8.46043 10.5001 8.0002 10.5001C7.53996 10.5001 7.16686 10.127 7.16686 9.66678V6.33345Z",
    fill: "#EE0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83353 12.1668C8.83353 12.627 8.46043 13.0001 8.0002 13.0001C7.53996 13.0001 7.16686 12.627 7.16686 12.1668C7.16686 11.7065 7.53996 11.3334 8.0002 11.3334C8.46043 11.3334 8.83353 11.7065 8.83353 12.1668Z",
    fill: "#EE0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.9d2a1f4d502f3911184603258616ff4d.svg";
export { ForwardRef as ReactComponent };